import { h } from 'preact';
import cssStyle from './index.css';
import CtaIcon from './icon';
import { RootStore } from '../../js/stores/root.store';

type Props = {
  colors: {
    primaryColor: string;
    secondaryColor: string;
  };
  cta: {
    label: string;
    animationDelay: number;
  };
  canUpdateStyle: boolean;
};

export default function CtaControl({ colors, cta, canUpdateStyle }: Props) {
  const canApplyTransition = !RootStore.getInstance().videoStore
    .isVideoCompleted.value;
  const ctaStyle = {
    background: colors.secondaryColor,
    color: colors.primaryColor
  };

  const ctaStyleReverse = {
    background: colors.primaryColor,
    color: colors.secondaryColor,
    transition: canApplyTransition
      ? 'color .3s ease-out, background .3s ease-out'
      : ''
  };

  const textStyle = {
    color: colors.primaryColor
  };
  const textReverseStyle = {
    color: colors.secondaryColor,
    transition: canApplyTransition ? 'color .3s ease-out' : ''
  };

  const iconStyle = {
    fill: colors.primaryColor
  };
  const iconReverseStyle = {
    fill: colors.secondaryColor,
    transition: canApplyTransition ? 'fill .3s ease-out' : ''
  };

  return (
    <div
      id="ctaControl"
      className={cssStyle.ctaContainer}
      style={canUpdateStyle ? ctaStyleReverse : ctaStyle}
    >
      <div
        className={cssStyle.ctaText}
        style={canUpdateStyle ? textReverseStyle : textStyle}
      >
        {cta.label}
      </div>
      <CtaIcon iconStyle={canUpdateStyle ? iconReverseStyle : iconStyle} />
    </div>
  );
}
